export default {
    computed: {
        image () {
            return this.collection.image.url
        },
        isImage () {
            return this.image
        }
    }
}
